<template>
  <button
    class="btn btn-primary btn-lg save-next"
    :disabled="disabled"
    @click="submit"
  >
    {{ label || lang.get('buttons.saveNext') }}
  </button>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  inject: ['lang'],
  props: {
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isSaveable ||
        !this.isLoaded ||
        this.ajaxInProgress
      );
    },
    ...mapState('entryForm', ['uploadInProgress']),
    ...mapGetters('entryForm', ['isSaveable', 'isLoaded']),
    ...mapState('entryFormApi', ['ajaxInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    ...mapActions('entryFormApi', { submit: 'saveAndNext' })
  }
};
</script>
